module.exports = __webpack_public_path__ + "img/103.english.6125db78.svg";